<div class="flex flex-col column-filter-dialog">
  <div class="flex flex-col pb-10">
    <div class="flex flex-row items-center justify-between">
      <div class="mat-subtitle-1 mb--6 fw-600">{{ title }}</div>
      <div class="flex flex-row items-center">
        <button class="apply-cancel accent" type="button" (click)="resetFilterColumn()">{{'BUTTONS.RESET' | transloco}}</button>
        <mat-icon svgIcon="close" class="cursor-pointer icon-md ml-20" (click)="clearData(); sidenavService.closeRightSidenav();"></mat-icon>
      </div>
    </div>
    <div class="mat-body-1 fw-400 mt-6">{{ subtitle }}</div>
  </div>
  <mat-divider class="mb-20 divider"></mat-divider>

  <ng-container *ngIf="name === 'Environment'">
    <div class="content mb-42">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'type'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'tenant'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'type' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let option of type" (click)="selectOptionsType(option)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="option.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{option.label | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'tenant' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <!--Individual tenant selection-->
          <!-- <div *ngFor="let tenant of tenant" (click)="selectOptionsTenant(tenant)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="tenant.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{tenant.value | titlecase}}
            </div>
          </div> -->

          <!--Multiple tenant selection-->
          <div *ngFor="let tenant of tenant" (click)="selectOptionsTenant(tenant)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="tenant.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md-1 mr-12" [ngClass]="{'disabled': tenantMaxLimit && !tenant.selected}"></mat-icon>
              {{tenant.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of status" (click)="selectOptionsStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{status.value | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>
    <mat-divider class="divider mt-10 mb-10"></mat-divider>
    <div class="flex flex-row filtering-actions ml-auto">

      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="dataListTenant?.length <= 0 && !dataListStatus && !dataListType ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="name === 'Subscription'">
    <div class="content mb-42">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'tenant'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'tenant' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let tenant of tenant" (click)="selectOptionsTenant(tenant)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="tenant.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{tenant.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of status" (click)="selectOptionsStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{status.value | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>
    <mat-divider class="divider mt-10 mb-10"></mat-divider>
      <div class="flex flex-row filtering-actions ml-auto">

        <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
          <button class="apply-cancel accent" [ngClass]="dataListTenant?.length <= 0 ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
          <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
        </div>
      </div>
    </ng-container>

  <ng-container *ngIf="name === 'Route'">
    <div class="content mb-42">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'direction'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'destinationType'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'direction' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let direction of direction" (click)="selectOptionsDirection(direction)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="direction.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{direction.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of status" (click)="selectOptionsStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{status.label | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'destinationType' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let destinationType of destinationType" (click)="selectOptionsDestinationType(destinationType)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="destinationType.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{destinationType.value | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>
    <mat-divider class="divider mt-10 mb-10"></mat-divider>
      <div class="flex flex-row filtering-actions ml-auto">

        <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
          <button class="apply-cancel accent" [ngClass]="!dataListDirection && !dataListStatus && !dataListDestinationType? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
          <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="name === 'Db'">
      <div class="content mb-42">
        <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
          <div class="flex flex-row justify-between w-100-percent" (click)="showHide(columnFilterItem)">
            <div class="flex flex-row">
              <div class="btn-font-rounded">{{columnFilterItem.label | titlecase}}</div>
            </div>
            <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
            <mat-icon *ngIf="columnFilterItem.item === 'dbType'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
            <mat-icon *ngIf="columnFilterItem.item === 'dbName'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          </div>
          <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
            <div *ngFor="let status of status" (click)="selectOptionsStatus(status)">
              <div class="flex flex-row mb-20">
                <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
                {{status.name | titlecase}}
              </div>
            </div>
          </div>
          <div *ngIf="columnFilterItem.item === 'dbType' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
            <div *ngFor="let status of dbType" (click)="selectOptionsDBType(status)">
              <div class="flex flex-row mb-20">
                <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
                {{status.name | titlecase}}
              </div>
            </div>
          </div>
          <div *ngIf="columnFilterItem.item === 'dbName' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
            <div *ngFor="let status of dbName" (click)="selectOptionsDbName(status)">
              <div class="flex flex-row mb-20">
                <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
                {{status.name | titlecase}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span class="flex-auto"></span>
      <mat-divider class="divider mt-10 mb-10"></mat-divider>
        <div class="flex flex-row filtering-actions ml-auto">

          <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
            <button class="apply-cancel accent" [ngClass]="(dbStatusList?.length === 0 && dbTypeList?.length === 0 &&  dbNameList?.length === 0) ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
            <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
          </div>
        </div>
      </ng-container>
  <ng-container *ngIf="name === 'Solutions'">
    <div class="content mb-42">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of status" (click)="selectOptionsStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{status.value | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

      <div class="flex flex-row filtering-actions ml-auto">
        <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
          <button class="apply-cancel accent" [ngClass]="!dataListRegion && !dataListStatus && !dataListCloud ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
          <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
        </div>
      </div>
    </ng-container>

  <ng-container *ngIf="name === 'Tenant'">
    <div class="content mb-42">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'type'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'region'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'cloud'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'type' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let type of type" (click)="selectOptionsType(type)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="type.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{type.label | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'region' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let region of region" (click)="selectOptionsRegion(region)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="region.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{region.value}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'cloud' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let cloud of cloud" (click)="selectOptionsCloud(cloud)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="cloud.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{cloud.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of status" (click)="selectOptionsStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{status.value | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="!dataListType && !dataListRegion && !dataListStatus && !dataListCloud ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="name === 'Solution'">
    <div class="content mb-42">
      <div *ngFor="let columnFilterItem of columnFilterItems" [ngClass]="{'flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10': (columnFilterItem.item === 'lineOfBusiness' || columnFilterItem.item === 'category' || (columnFilterItem.item === 'tenant' && page !== 'tenantSolutions'))}">
        <div class="flex flex-row justify-between w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div *ngIf="columnFilterItem.item === 'lineOfBusiness' || columnFilterItem.item === 'category' || (columnFilterItem.item === 'tenant' && page !== 'tenantSolutions')" class="btn-font-rounded">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'lineOfBusiness'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'category'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <!-- <mat-icon *ngIf="columnFilterItem.item === 'region'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon> -->
          <mat-icon *ngIf="columnFilterItem.item === 'tenant' && page !== 'tenantSolutions'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'lineOfBusiness' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let lineOfBusiness of lineOfBusiness" (click)="selectOptionsLineOfBusiness(lineOfBusiness)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="lineOfBusiness.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{lineOfBusiness.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'category' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let category of category" (click)="selectOptionsCategory(category)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="category.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{category.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'region' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let region of region" (click)="selectOptionsRegion(region)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="region.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{region.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'tenant' && columnFilterItem.selected && page !== 'tenantSolutions'" class="flex flex-col self-start mt-4">
          <div *ngFor="let tenant of tenant" (click)="selectOptionsTenant(tenant)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="tenant.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{tenant.value | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="!dataListRegion && !dataListStatus && !dataListCloud && !dataListLineOfBusiness && !dataListCategory && dataListTenant?.length <= 0 ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>



  <ng-container *ngIf="page === 'service_def'">
    <div class="content mb-42 solution-text">
      <div *ngFor="let columnFilterItem of columnFilterItems" [ngClass]="{'flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10': (columnFilterItem.item === 'solution')}">
        <div class="flex flex-row justify-between w-100-percent solution-header" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
              <div *ngIf="columnFilterItem.item === 'solution'" class="btn-font-rounded">
                  {{ columnFilterItem.label | titlecase }}
              </div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'solution'"  [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'"  class="mt-2"></mat-icon>
      </div>

        <div *ngIf="columnFilterItem.item === 'solution' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let solution of solution" (click)="selectOptionsSolutions(solution)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="solution.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-12"></mat-icon>
              {{solution.value | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="!dataListSolution ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="name === 'LocalConfig'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems"
        class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">
              {{columnFilterItem.label | titlecase}}
            </div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>

        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected"
          class="flex flex-col self-start date-filters">
          <div *ngFor="let date of filterOptions; let first = first">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}"> 
              <!-- Checkbox row -->
              <div class="flex flex-row mb-16" (click)="updateSelectedDate(date)">
                <mat-icon [svgIcon]="date.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{date.value | titlecase}}
              </div>
              <!-- Date pickers shown only when checkbox is selected -->
              <div *ngIf="date.selected" class="flex flex-col">
                <div *ngIf="first" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco}}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="lcPicker" (dateChange)="startDateItemChange($event)" (click)="lcPicker.open()" placeholder="MM/DD/YYYY" [value]="startDateTest" [min]="dateCreated" [max]="endDateTest ? endDateTest : maxDate"
                         readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="lcPicker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #lcPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco}}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="lcPicker1" (dateChange)="endDateItemChange($event)" (click)="lcPicker1.open()" placeholder="MM/DD/YYYY" [value]="endDateTest" [min]="startDateTest ? startDateTest : dateCreated" [max]="maxDate"
                        readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="lcPicker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #lcPicker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <span class="flex-auto"></span>
    <mat-divider class="divider mt-10 mb-10"></mat-divider>
    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="selectedDateList?.length === 0 
            || (filterOptions?.[0]?.selected && (!validStartDateChange || !validEndDateChange)) 
            || !enableApplySchedule ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.CONFIRM' |
          transloco}}</button>
        <button class="apply-cancel white" type="button"
          (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>


  <ng-container *ngIf="name === 'InstanceActivity'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'action'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'action' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let action of action" (click)="selectOptionsAction(action)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="action.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{action.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-row self-start date-filters">
          <div class="flex flex-col date-field">
            <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.FROM' | transloco }}</div>
            <mat-form-field class="example-full-width">
              <input matInput [matDatepicker]="picker" (dateChange)="startDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="startDate" [min]="dateCreated" [max]="endDate || today" readonly>
              <mat-datepicker-toggle matIconSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div  class="flex flex-col date-field ml-32">
            <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.TO' | transloco }}</div>
            <mat-form-field class="example-full-width">
              <input matInput [matDatepicker]="picker1" (dateChange)="endDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="endDate" [min]="startDate || dateCreated" [max]="today" readonly>
              <mat-datepicker-toggle matIconSuffix [for]="picker1">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="!(dataListAction?.length === 0 && initialDataListAction?.length !== 0) && dataListAction?.length <= 0 && !((initialStartDate !== startDate || initialEndDate !== endDate) && startDate && endDate) ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  @if (name === 'BaseImage') {
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        @if (columnFilterItem.item === 'date' && columnFilterItem.selected) {
          <div class="flex flex-col self-start date-filters mt-4">
            <div *ngFor="let dateOption of filterOptions" class="flex flex-col">
              <div class="flex flex-row mb-16" (click)="updateSelectedDate(dateOption)">
                <mat-icon [svgIcon]="dateOption.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{dateOption.value | titlecase}}
              </div>
              <div *ngIf="dateOption.selected" class="flex flex-row">
                <div class="flex flex-col date-field">
                  <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco}}</div>
                  <mat-form-field class="example-full-width">
                    <input matInput [matDatepicker]="biPickerFrom" (dateChange)="startDateChange($event)" (click)="biPickerFrom.open()" placeholder="MM/DD/YYYY" [value]="startDate" [min]="dateCreated" [max]="endDate || today" readonly>
                    <mat-datepicker-toggle matIconSuffix [for]="biPickerFrom">
                      <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker [startAt]="startDate" #biPickerFrom></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="flex flex-col date-field ml-32">
                  <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco}}</div>
                  <mat-form-field class="example-full-width">
                    <input matInput [matDatepicker]="biPickerTo" (dateChange)="endDateChange($event)" (click)="biPickerTo.open()" placeholder="MM/DD/YYYY" [value]="endDate" [min]="startDate || dateCreated" [max]="today" readonly>
                    <mat-datepicker-toggle matIconSuffix [for]="biPickerTo">
                      <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #biPickerTo></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="!filterOptions?.[0]?.selected || !(startDate && endDate) ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  }

  <ng-container *ngIf="name === 'Jumpbox'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'zone'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of JBStatus" (click)="selectOptionsJBStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'zone' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let zone of JBZone" (click)="selectOptionsJBZone(zone)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="zone.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{zone.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let dt of JBDate; let last = last">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="selectOptionsJBDate(dt)">
                <mat-icon [svgIcon]="dt.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{dt.value | titlecase}}
              </div>
              <div *ngIf="dt.selected" class="flex flex-col">
                <div *ngIf="!last" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker" (dateChange)="startDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="startDate" [min]="minDate" [max]="endDate || maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="endDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="endDate" [min]="startDate" [max]="maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="last" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker2" (dateChange)="startModifiedDateChange($event)" (click)="picker2.open()" placeholder="MM/DD/YYYY" [value]="filterModifiedStartDate" [min]="minDate" [max]="filterModifiedEndDate || maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker2">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="filterModifiedStartDate" #picker2></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker3" (dateChange)="endModifiedDateChange($event)" (click)="picker3.open()" placeholder="MM/DD/YYYY" [value]="filterModifiedEndDate" [min]="filterModifiedStartDate" [max]="maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker3">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker3></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="
        JBStatusList?.length === 0 && JBZoneList?.length === 0 && JBDateList?.length === 0
        || (JBDate[0].selected && (!validStartDate || !validEndDate))
        || (JBDate[1].selected && (!validFilterModifiedStartDate || !validFilterModifiedEndDate)) ?
        'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="name === 'privateendpoints'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of PEStatus" (click)="selectOptionsPEStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="
        PEStatusList?.length === 0? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="name === 'inventoryFilters'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'type'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'type' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let type of inventoryTypeList" (click)="selectOptionsInventoryCloud(type)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="type.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{type.label | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="
        inventoryTypeList?.length === 0? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
   <ng-container *ngIf="name === 'ProdVersionFilters'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'version'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'isManaged'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'version' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let version of inventoryProdVersionList" (click)="selectOptionsInventoryProduct(version)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="version.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{version.label | titlecase}}
            </div>
          </div>
        </div>
         <div *ngIf="columnFilterItem.item === 'isManaged' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let isManaged of inventoryProdIsManagedList" (click)="selectOptionsInventoryIsManaged(isManaged)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="isManaged.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{isManaged.label | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="
        inventoryProdVersionList.length === 0? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="name === 'scheduleFilters'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'triggers'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of scheduleStatusList" (click)="selectOptionsScheduleStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'triggers' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let zone of scheduleTriggerList" (click)="selectOptionsScheduleTrigger(zone)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="zone.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{zone.label | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let dt of scheduleDate; let first = first">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="selectOptionsScheduleDate(dt)">
                <mat-icon [svgIcon]="dt.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{dt.value | titlecase}}
              </div>
              <div *ngIf="dt.selected" class="flex flex-col">
                <div *ngIf="first" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker" (dateChange)="scheduleStartDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="scheduleStartDate" [max]="scheduleEndDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="scheduleEndDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="scheduleEndDate" [min]="scheduleStartDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="
        (scheduleDate[0].selected && (!validSchStartDate || !validSchEndDate)) || !enableApplySchedule?
        'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="name === 'scheduleDetailFilters'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of scheduleStatusDetailList" (click)="selectOptionsScheduleDetailStatus(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let dt of scheduleDetailDate; let last = last">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="selectOptionsDetailScheduleDate(dt)">
                <mat-icon [svgIcon]="dt.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{dt.value | titlecase}}
              </div>
              <div *ngIf="dt.selected" class="flex flex-col">
                <div *ngIf="last" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker" (dateChange)="scheduleDetailStartDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="scheduleDetailStartDate" [max]="scheduleDetailEndDate || maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="scheduleDetailEndDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="scheduleDetailEndDate" [min]="scheduleDetailStartDate" [max]="maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="scheduleStatusDetailSelList?.length === 0 && schDateDetailSelList?.length === 0
        || (scheduleDetailDate[0].selected && (!validSchDetailStartDate || !validSchDetailEndDate)) ?
        'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="name === 'Components'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let status of componentStatus" (click)="selectOptionsComponents(status)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label | titlecase}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>
    <!-- <mat-divider class="divider mt-10 mb-10"></mat-divider> -->
    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="componetStatusList?.length === 0? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="name === 'Metrics'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'action'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'action' && columnFilterItem.selected" class="flex flex-col self-start mt-4">
          <div *ngFor="let action of metricAction" (click)="selectMetricAction(action)">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="action.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{action.value | titlecase}}
            </div>
          </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-row self-start date-filters">
          <div class="flex flex-col date-field">
            <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.FROM' | transloco }}</div>
            <mat-form-field class="example-full-width">
              <input matInput [matDatepicker]="picker" (dateChange)="metricStartDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="metricStartDate" readonly [min]="metricMinDate" [max]="metricEndDate ? metricEndDate : metricMaxDate">
              <mat-datepicker-toggle matIconSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker [startAt]="metricStartDate" #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div  class="flex flex-col date-field ml-32">
            <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.TO' | transloco }}</div>
            <mat-form-field class="example-full-width">
              <input matInput [matDatepicker]="picker1" (dateChange)="metricEndDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="metricEndDate" readonly [min]="metricStartDate ? metricStartDate: metricMinDate" [max]="metricMaxDate">
              <mat-datepicker-toggle matIconSuffix [for]="picker1">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions ml-auto">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="!enableApplyMetric && !metricDateSelected ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="name === 'Custom Image'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'createdby'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'createdby' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let created of customCreatedBy" (click)="selectOptionsCustomImageCreated(created)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="created.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{created.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let date of createdDate; let first = first">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="selectOptionsCustomImageDate(date)">
                <mat-icon [svgIcon]="date.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{date.value | titlecase}}
              </div>
              <div *ngIf="date.selected" class="flex flex-col">
                <div *ngIf="first" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker" (dateChange)="customImagesStartDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="customImageStartDateChange" [min]="minDate" [max]="customImageEndDateChange || maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="customImagesEndDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="customImageEndDateChange" [min]="customImageStartDateChange" [max]="maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="customImageDateList?.length === 0 && customImageCreatedByList?.length === 0 || (createdDate[0].selected && (!validCustomStartDate || !validCustomEndDate)) ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="name === 'Runbook'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <!-- <mat-icon *ngIf="columnFilterItem.item === 'type'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon> -->
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'version'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <!-- <div *ngIf="columnFilterItem.item === 'type' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let type of runbookTypeList" (click)="selectOptionsRunbookType(type)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="type.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{type.label}}
            </div>
          </div>
         </div>
        </div> -->
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let status of runbookStatusList" (click)="selectOptionsRunbookStatus(status)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'version' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let version of runbookVersionList" (click)="selectOptionsRunbookVersion(version)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="version.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{version.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let date of modifiedDate; let first = first">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="selectOptionsRunbookDate(date)">
                <mat-icon [svgIcon]="date.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{date.value | titlecase}}
              </div>
              <div *ngIf="date.selected" class="flex flex-col">
                <div *ngIf="first" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker" (dateChange)="runbookItemStartDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="runbookStartDateChange" [min]="dateCreated" [max]="runbookEndDateChange || today" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="runbookItemEndDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="runbookEndDateChange" [min]="runbookStartDateChange || dateCreated" [max]="today" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="runbookTypeList?.length === 0 && runbookStatusList?.length === 0 && runbookVersionList?.length === 0 && runbookDateList?.length === 0 || (modifiedDate[0].selected && (!validRunbookStartDate || !validRunbookEndDate)) || !enableApplySchedule ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

  <!-- job filter -->
    <ng-container *ngIf="name === 'Jobs'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'schedule'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'runbook'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'schedule' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let schedule of scheduleList" (click)="selectOptionsJobSchedule(schedule)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="schedule.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{schedule.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'runbook' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let runbook of runbookList" (click)="selectOptionsJobSRunbook(runbook)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="runbook.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{runbook.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let status of statusList" (click)="selectOptionsJobsStatus(status)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let date of Date; let first = first">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="selectOptionsJobsDate(date)">
                <mat-icon [svgIcon]="date.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{date.value | titlecase}}
              </div>
              <div *ngIf="date.selected" class="flex flex-col">
                <div *ngIf="first" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                    <input matInput [matDatepicker]="picker" (dateChange)="jobItemStartDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="jobStartDateChange" [min]="dateCreated" [max]="jobEndDateChange ? jobEndDateChange : maxDate" readonly>                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="jobItemEndDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="jobEndDateChange" [min]="jobStartDateChange ? jobStartDateChange : dateCreated" [max]="maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
         <button class="apply-cancel accent" [ngClass]="scheduleList?.length === 0 && runbookList?.length === 0 && statusList?.length === 0 && Date?.length === 0 || (Date?.[0]?.selected && (!validJobStartDate || !validJobEndDate)) || !enableApplySchedule ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

   <!-- sizing doc filter -->
    <ng-container *ngIf="name === 'Sizing Documents'">
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'version'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
      
       
        <div *ngIf="columnFilterItem.item === 'version' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let version of serviceDefVersionList" (click)="selectOptionsSizingVersion(version)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="version.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{version.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let date of filterOptions; let first = first">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="updateSelectedDate(date)">
                <mat-icon [svgIcon]="date.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{date.value | titlecase}}
              </div>
              <div *ngIf="date.selected" class="flex flex-col">
                <div *ngIf="first" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                    <input matInput [matDatepicker]="picker" (dateChange)="startDateItemChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="startDateTest" [min]="dateCreated" [max]="endDateTest ? endDateTest : maxDate" readonly>                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="endDateItemChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="endDateTest" [min]="startDateTest ? startDateTest : dateCreated" [max]="maxDate" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
         <button class="apply-cancel accent" [ngClass]=" serviceDefVersionList?.length === 0 && filterOptions?.length === 0 || (filterOptions?.[0]?.selected && (!validStartDateChange || !validEndDateChange)) || !enableApplySchedule ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>

@if (name === 'Schedule') {
  <ng-container>
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'date'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let status of envScheduleStatusList" (click)="selectOptionsEnvScheduleStatus(status)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'date' && columnFilterItem.selected" class="flex flex-col self-start date-filters">
          <div *ngFor="let date of envScheduleModifiedDate; let first = first">
            <div class="flex flex-col" [ngClass]="{'mt-20': !last}">
              <div class="flex flex-row mb-16" (click)="selectOptionsEnvScheduleDate(date)">
                <mat-icon [svgIcon]="date.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
                {{date.value | titlecase}}
              </div>
              <div *ngIf="date.selected" class="flex flex-col">
                <div *ngIf="first" class="flex flex-row">
                  <div class="flex flex-col date-field">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.START_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker" (dateChange)="envScheduleItemStartDateChange($event)" (click)="picker.open()" placeholder="MM/DD/YYYY" [value]="envScheduleStartDateChange" [min]="dateCreated" [max]="envScheduleEndDateChange || today" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [startAt]="startDate" #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div  class="flex flex-col date-field ml-32">
                    <div class="mat-subtitle-1 fw-500 fs-12 mb-0">{{'INSTANCE_DETAILS.END_DATE' | transloco }}</div>
                    <mat-form-field class="example-full-width">
                      <input matInput [matDatepicker]="picker1" (dateChange)="envScheduleItemEndDateChange($event)" (click)="picker1.open()" placeholder="MM/DD/YYYY" [value]="envScheduleEndDateChange" [min]="envScheduleStartDateChange || dateCreated" [max]="today" readonly>
                      <mat-datepicker-toggle matIconSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon svgIcon="calendar_today" class="icon-sm ml-4"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="envScheduleStatusList?.length === 0 && envScheduleDateList?.length === 0 || (envScheduleModifiedDate[0].selected && (!validEnvScheduleStartDate || !validEnvScheduleEndDate) || !enableApplySchedule ) ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
}
@if (name === 'Job Details') {
  <ng-container>
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let status of envJobDetailStatusList" (click)="selectOptionsEnvJobDetailstatus(status)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label}}
            </div>
          </div>
         </div>
        </div>
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="envJobDetailStatusList?.length === 0 || !enableApplySchedule ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
}


  <!-- database backup filter -->
   @if (name === 'Database Backup') {
    <ng-container>
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
          <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'dbType'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          <mat-icon *ngIf="columnFilterItem.item === 'dbName'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
        </div>
         <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let status of statusList" (click)="selectOptionsDBStatus(status)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.name}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'dbType' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let dbType of dbTypeList" (click)="selectOptionDBType(dbType)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="dbType.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{dbType.name}}
            </div>
          </div>
         </div>
        </div>
        <div *ngIf="columnFilterItem.item === 'dbName' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let dbName of dbNameList" (click)="selectOptionDBName(dbName)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="dbName.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{dbName.name}}
            </div>
          </div>
         </div>
        </div>
       
      </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
         <button class="apply-cancel accent" [ngClass]="scheduleList?.length === 0 && runbookList?.length === 0 && statusList?.length === 0 && Date?.length === 0 || (Date?.[0]?.selected && (!validJobStartDate || !validJobEndDate)) || !enableApplySchedule ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
}
@if(name === 'Sanity Test'){
<ng-container>
    <div class="content">
      <div *ngFor="let columnFilterItem of columnFilterItems" class="flex flex-col justify-between column-filter-item mb-16 pt-10 pb-10">
        <div class="flex flex-row justify-between items-center w-100-percent" (click)="showHide(columnFilterItem)">
          <div class="flex flex-row">
            <div class="btn-font-rounded" [ngClass]="{'deselected': !columnFilterItem.selected}">{{columnFilterItem.label | titlecase}}</div>
          </div>
           <mat-icon *ngIf="columnFilterItem.item === 'status'" [svgIcon]="columnFilterItem.selected ? 'expand_less' : 'expand_more'" class="mt-2"></mat-icon>
          </div>
        <div *ngIf="columnFilterItem.item === 'status' && columnFilterItem.selected" class="flex flex-col self-start mt-4 createdby-wrapper">
          <div class="createdby-scroll">
            <div *ngFor="let status of sanityTestStatusList" (click)="selectOptionsSanityTestStatus(status)" class="createdby-item">
            <div class="flex flex-row mb-20">
              <mat-icon [svgIcon]="status.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon cursor-pointer icon-md-1 mr-12"></mat-icon>
              {{status.label}}
            </div>
          </div>
         </div>
        </div>
       </div>
    </div>

    <span class="flex-auto"></span>

    <mat-divider class="divider mt-10 mb-10"></mat-divider>

    <div class="flex flex-row filtering-actions place-content-end">
      <div dir="rtl" class="flex flex-row gap-x-4 mb-10">
        <button class="apply-cancel accent" [ngClass]="sanityTestStatusList?.length === 0 || !enableApplySanityFilter ? 'disabled' : 'enabled'" type="button" (click)="applyFilter()">{{'BUTTONS.APPLY' | transloco}}</button>
        <button class="apply-cancel white" type="button" (click)="clearData(); sidenavService.closeRightSidenav();">{{'BUTTONS.CANCEL' | transloco}}</button>
      </div>
    </div>
  </ng-container>
}
</div>